import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_JSM_CUSTOMER_ACCESS_AFFECTED_PROJECTS } from './resourceTypeJsmGlobalCustomerAccessSettings.constants.tsx';
import type { JsmCustomerAccessAffectedProjectsResponse } from './JsmCustomerAccessAffectedProjectsResponse.types.tsx';
import getDataForProjectType from './getDataForProjectType.tsx';

const ONE_DAY_IN_MILLIS = 1000 * 60 * 60 * 24;

export const jsmGlobalCustomerAccessAffectedProjectsResource: RouteResource<JsmCustomerAccessAffectedProjectsResponse> =
	createResource<JsmCustomerAccessAffectedProjectsResponse>({
		type: RESOURCE_TYPE_JSM_CUSTOMER_ACCESS_AFFECTED_PROJECTS,
		getKey: () => 'affected-projects',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-jsm-customer-access-affected-projects", jiraSpaEntry: "async-resource-jsm-customer-access-affected-projects" */ './getDataWithErrorLogging.tsx'
			),
		maxAge: ONE_DAY_IN_MILLIS,
	});

export const jsmFilteredAffectedProjectsResource: RouteResource<JsmCustomerAccessAffectedProjectsResponse> =
	createResource<JsmCustomerAccessAffectedProjectsResponse>({
		type: 'JSM_FILTERED_AFFECTED_PROJECTS',
		getKey: () => 'affected-projects-jsm',
		getData: getDataForProjectType('service_desk'),
		maxAge: ONE_DAY_IN_MILLIS,
	});

export const csmFilteredAffectedProjectsResource: RouteResource<JsmCustomerAccessAffectedProjectsResponse> =
	createResource<JsmCustomerAccessAffectedProjectsResponse>({
		type: 'CSM_FILTERED_AFFECTED_PROJECTS',
		getKey: () => 'affected-projects-csm',
		getData: getDataForProjectType('customer_service'),
		maxAge: ONE_DAY_IN_MILLIS,
	});
